<template>
  <Container type="card-full">
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
          isOperate :operateBtn="{'chg':'chg','del':'del'}" @CHG="chgComType" @DEL="delComType">
        <template slot="btn">
              <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'ComTypeApplyIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comtypename', fieldtype: 'C', title: '角色类型',calculExpr:'', addNewRowFlg: false},
          { field: 'comtypestatusname', fieldtype: 'C', title: '申请状态',calculExpr:'',addNewRowFlg: false},
          { field: 'applyusername', fieldtype: 'C',title: '申请人',calculExpr:'',addNewRowFlg: false},
          { field: 'comtypeapplytime', fieldtype: 'T',title: '申请时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'checkusername', fieldtype: 'C',title: '审核人',calculExpr:'',addNewRowFlg: false},
          { field: 'comtypechecktime', fieldtype: 'T',title: '审核时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        comtype: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addComType())
      // this.$on('CHG', () => this.chgComType())
      // this.$on('DEL', () => this.delComType())
      // this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addComType () {
        let form = {
          comid: this.$store.getters.loginUser.usercomid
        }
        this.$router.push({name: 'comTypeApplyForm', params: {form: form, type: 1}})
      },
      async chgComType (row) {
        this.comtype = row
        if (this.comtype.comtypestatus === '1') {
          this.$message.warning('已审核，不能修改')
          return
        }
        this.$router.push({name: 'comTypeApplyForm', params: {form: this.comtype, type: 2}})
      },
      async delComType (row) {
        this.comtype = row
        if (this.comtype.comtypestatus === '1') {
          this.$message.warning('已审核，不能删除')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/com/delComType',
            method: "post",
            data: this.comtype
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async cellClick (row) {
        this.comtype = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/com/getComtypePageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
